import {Component, ChangeDetectionStrategy} from '@angular/core';
import {AgRendererComponent} from 'ag-grid-angular';

@Component({ standalone: false,
    selector: 'irb-grid-up-down-reorder-cell',
    templateUrl: './up-down-reorder-cell.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UpDownReorderCellComponent implements AgRendererComponent {
    params: any;
    get firstRow() {
        const rowIndex = this.params.rowIndex || this.params.node.rowIndex;
        return this.params && rowIndex === 0;
    }
    get lastRow() {
        const rowIndex = this.params.rowIndex || this.params.node.rowIndex;
        return this.params && (rowIndex === (this.rowCount - 1));
    }
    rowCount: number = 0;
    constructor() {
    }

    agInit(params: any) {
        this.params = params;
        this.rowCount = this.params.api.getDisplayedRowCount();
    }

    refresh(): boolean {
        return false;
    }

    downClick() {
        if(typeof this.params.downClick != "undefined") {
            if(!this.lastRow) {
                this.params.downClick(this.params);
            }
        }
    }

    upClick() {
        if(typeof this.params.upClick != "undefined") {
            if(!this.firstRow) {
                this.params.upClick(this.params);
            }

        }
    }

    getUpImage() {
        if(this.firstRow) {
            return '../../assets/images/up_arrow_grey.png';
        } else {
            return '../../assets/images/up_arrow_blue.png';
        }

    }
    getDownImage() {
        if(this.lastRow) {
            return '../../assets/images/down_arrow_grey.png';
        } else {
            return '../../assets/images/down_arrow_blue.png';
        }

    }
}
